import {collectPlantIds, UpmPlantsHierarchyNode} from '@domain/upm'

interface UpmPlantIdMapping {
  upmId: string
  plantId: string
}

export const resolveAreaPlantIds = ({
  areaHierarchyId,
  hierarchy,
  upmPlants
}: {
  areaHierarchyId: string | undefined
  hierarchy: UpmPlantsHierarchyNode | undefined
  upmPlants: Record<string, UpmPlantIdMapping>
}): string[] | undefined => {
  if (!areaHierarchyId || !hierarchy) return undefined

  const areaNode = hierarchy.children.find((node) => node.hierarchyId === areaHierarchyId)
  if (!areaNode) return undefined

  const upmIds = collectPlantIds(areaNode)
  const upmIdToPlantId = new Map(
    Object.values(upmPlants).map((plant) => [plant.upmId, plant.plantId])
  )

  return upmIds
    .map((upmId) => upmIdToPlantId.get(upmId))
    .filter((id): id is string => id !== undefined)
}
